import { render, staticRenderFns } from "./notnav.vue?vue&type=template&id=1ca75776&scoped=true&"
import script from "./notnav.vue?vue&type=script&lang=js&"
export * from "./notnav.vue?vue&type=script&lang=js&"
import style0 from "./notnav.vue?vue&type=style&index=0&id=1ca75776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca75776",
  null
  
)

export default component.exports